import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { LoansandoverdrawnbankSoletraderService } from './service/loansandoverdrawnbank-soletrader.service';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';

@Component({
  selector: 'app-loansandoverdrawnbank-soletrader',
  templateUrl: './loansandoverdrawnbank-soletrader.component.html',
  styleUrls: ['./loansandoverdrawnbank-soletrader.component.scss']
})
export class LoansandoverdrawnbankSoletraderComponent implements OnInit {
  LoansandoverdrawnbankSoletraderFormgGroup: FormGroup;

  Grid_Total1: number;
  Grid_Total2: number;
  isJump: any;
  showBubbledata: any;
  NormalRoutng: boolean; disableLoansandoverdrawbanks: boolean
  valid: boolean = true;
  constructor(private FormBuilder: FormBuilder, private LoansandoverdrawnbankSoletraderService: LoansandoverdrawnbankSoletraderService, public commonService: CommonService, private Router: Router, private sidenav: SideNavService) {

  }

  ngOnInit() {

    debugger
    this.commonService.getIncomeStatementsHeaders();
    this.isJump = localStorage.getItem('isJump');
    this.createformgroup();
    this.wizardrowslist.clear();
    this.GetLoansandoverdrawnbankSoletrader();
      this.commonService.getNotesData();
      this.clearfield();
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.LoansandoverdrawnbankSoletraderFormgGroup.controls['APPeriodId'].value).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.GetLoansandoverdrawnbankSoletrader_LY()
      }
    })
    if (localStorage.getItem("SubmitStatus") == "true")
      this.disableLoansandoverdrawbanks = true;

  }

  createformgroup() {
    this.LoansandoverdrawnbankSoletraderFormgGroup = this.FormBuilder.group({
      LoansAndOverdrawnBankId: new FormControl(),
      MasterId: new FormControl(),
      LoansAndOverdrawnBankSharePremiumSubtotal: new FormControl({ disabled: true, value: '' }),
      LoansAndOverdrawnBankSharePremiumSubtotal_LY: new FormControl({ disabled: true, value: null }),
      LoansAndOverdrawnBankFreeøtextComment: new FormControl(),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),

      MatchingData: new FormControl(),

      Wizardrows: this.FormBuilder.array([this.FormBuilder.group({
        DetailsId: new FormControl(),
        LoansAndOverdrawnBankId: new FormControl(),
        DescriptionShareType: new FormControl(),
        LoansAndOverdrawnBankSharePremiumSubtotal: new FormControl(),
        LoansAndOverdrawnBankSharePremiumSubtotal_LY: new FormControl(),
        CreatedBy: new FormControl(),
        CreatedDate: new FormControl(),
        ModifiedBy: new FormControl(),
        ModifiedDate: new FormControl(),
      })])
    });
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        var MatchingData = this.LoansandoverdrawnbankSoletraderFormgGroup.controls['MatchingData'].value;
        this.LoansandoverdrawnbankSoletraderFormgGroup.reset();
        this.wizardrowslist.clear();
        this.LoansandoverdrawnbankSoletraderFormgGroup.controls['MatchingData'].setValue({ Item1: MatchingData.Item1, Item2: MatchingData.Item2 });
        this.LoansandoverdrawnbankSoletraderFormgGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
      }
    })
  }

  GetLoansandoverdrawnbankSoletrader() {
    debugger;
    this.LoansandoverdrawnbankSoletraderService.getdata(this.LoansandoverdrawnbankSoletraderFormgGroup.controls['APPeriodId'].value).subscribe((data: any) => {
      debugger;
      if (data.Wizardrows)
        for (let i = 0; i < data.Wizardrows.length; i++) {
          this.wizardrowslist.push(this.FormBuilder.group({
            LoansAndOverdrawnBankId: data.Wizardrows[i].LoansAndOverdrawnBankId,
            DetailsId: data.Wizardrows[i].DetailsId,
            DescriptionShareType: data.Wizardrows[i].DescriptionShareType,
            LoansAndOverdrawnBankSharePremiumSubtotal: data.Wizardrows[i].LoansAndOverdrawnBankSharePremiumSubtotal,
            LoansAndOverdrawnBankSharePremiumSubtotal_LY: data.Wizardrows[i].LoansAndOverdrawnBankSharePremiumSubtotal_LY,
          }));
        }
      this.LoansandoverdrawnbankSoletraderFormgGroup.patchValue(data);
      this.LoansandoverdrawnbankSoletraderFormgGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));

    })
  }

  GetLoansandoverdrawnbankSoletrader_LY() {
    debugger;
    this.LoansandoverdrawnbankSoletraderService.getdata_LY(this.LoansandoverdrawnbankSoletraderFormgGroup.controls['APPeriodId'].value).subscribe((data: any) => {
      debugger;
      this.showBubbledata = data;
      this.LoansandoverdrawnbankSoletraderFormgGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));

    })
  }

  On_Next() {
    debugger;
    if (this.Gridvalidations() && this.On_NextBalancesheatValidaton()) {
      this.LoansandoverdrawnbankSoletraderService.insertdetails(this.LoansandoverdrawnbankSoletraderFormgGroup.getRawValue()).subscribe(data => {
        this.LoansandoverdrawnbankSoletraderFormgGroup.markAsPristine()
        if (this.NormalRoutng)
          return true;
        this.Router.navigate(['/otherliabilities']);
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Loans and Overdrawn bank account balances", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.Router.navigate(['/notes'])
        else if (nextPage == 'loansandoverdrawnbankaccountbalances') {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.Router.navigate([nextPage]);
        }
        else {
          this.Router.navigate([nextPage]);
        }
      })
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }

  On_Back() {
    debugger;
    this.LoansandoverdrawnbankSoletraderFormgGroup.markAsPristine()
    // this.Router.navigate(['/tradecreditors']);
    var backpage;
    backpage = this.commonService.getBackSelection("Loans and Overdrawn bank account balances", this.commonService.NotesList)
    if (this.isJump == 'true')
      this.Router.navigate(['/notes'])
    else {
      this.Router.navigate([backpage]);
    }
  }

  AddNew() {
    debugger;
    if (this.Gridvalidations()) {
      this.valid = true;
      this.wizardrowslist.push(this.FormBuilder.group({ LoansAndOverdrawnBankId: '', DescriptionShareType: '', LoansAndOverdrawnBankSharePremiumSubtotal: '', LoansAndOverdrawnBankSharePremiumSubtotal_LY: '', }));
    }
    //  this.wizardrowslist.clear();

  }

  DeleteRow(index) {
    debugger;
    Swal.fire({
      titleText: "Andica Accounts Production",
      text: 'Are you sure you want to delete?',
      icon: "question",
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false
    }).then((data) => {
      if (data.value) {
        this.wizardrowslist.removeAt(index);
        this.CalculationsGrid();
      }
    })
  }

  Gridvalidations() {
    debugger;
    if (this.wizardrowslist.length) {
      var data = [];
      for (var j = 0; j < this.wizardrowslist.length; j++) {
        var v = this.LoansandoverdrawnbankSoletraderFormgGroup.value.Wizardrows.filter(x => x.DescriptionShareType == this.wizardrowslist.value[j].DescriptionShareType)
        if (v.length > 1) {
          data = v;
          Swal.fire("Andica Accounts Production", "Item Description is already present.", 'warning');
          return false;
        }
      }
    }
    for (var i = 0; i < this.LoansandoverdrawnbankSoletraderFormgGroup.value.Wizardrows.length; i++) {
      if ((this.LoansandoverdrawnbankSoletraderFormgGroup.value.Wizardrows.length > 0) && (this.LoansandoverdrawnbankSoletraderFormgGroup.value.Wizardrows[i].DescriptionShareType == null || this.LoansandoverdrawnbankSoletraderFormgGroup.value.Wizardrows[i].DescriptionShareType == "")) {
        //Swal.fire("Andica Accounts Production", 'Item description must be completed.', 'warning');
        this.valid = false;
        return false;
      }
      else {
        this.valid = true;
      }
    }
    return true;
  }

  CalculationsGrid() {
    debugger;
    this.Grid_Total1 = 0;
    this.Grid_Total2 = 0;
    // this.SharecapitalFormgGroup.value.CreateTaxationFormGroupGrid

    for (var i = 0; i < this.wizardrowslist.length; i++) {
      this.Grid_Total1 = this.Grid_Total1 + +this.wizardrowslist.value[i].LoansAndOverdrawnBankSharePremiumSubtotal;
      this.Grid_Total2 = this.Grid_Total2 + +this.wizardrowslist.value[i].LoansAndOverdrawnBankSharePremiumSubtotal_LY;
    }
    this.LoansandoverdrawnbankSoletraderFormgGroup.controls['LoansAndOverdrawnBankSharePremiumSubtotal'].setValue(this.Grid_Total1)
    this.LoansandoverdrawnbankSoletraderFormgGroup.controls['LoansAndOverdrawnBankSharePremiumSubtotal_LY'].setValue(this.Grid_Total2)

  }

  On_NextBalancesheatValidaton() {
    debugger;


    if (this.commonService.showControl == true) {
      if (+this.LoansandoverdrawnbankSoletraderFormgGroup.controls['LoansAndOverdrawnBankSharePremiumSubtotal'].value != +this.LoansandoverdrawnbankSoletraderFormgGroup.controls['MatchingData'].value.Item1) {
        Swal.fire("Andica Accounts Production", "Total " + this.commonService.StartYear + " must tally with the Loans and overdrawn bank account balances field value in the Statement of Financial Position for the year " + this.commonService.StartYear + ".", 'warning')
        return false;
      }
      else if (+this.LoansandoverdrawnbankSoletraderFormgGroup.controls['LoansAndOverdrawnBankSharePremiumSubtotal_LY'].value != +this.LoansandoverdrawnbankSoletraderFormgGroup.controls['MatchingData'].value.Item2) {
        Swal.fire("Andica Accounts Production", "Total " + this.commonService.LastYear + " must tally with the Loans and overdrawn bank account balances field value in the Statement of Financial Position for the year " + this.commonService.LastYear + ".", 'warning')
        return false;
      }
      else
        return true
    }
    else {
      if (+this.LoansandoverdrawnbankSoletraderFormgGroup.controls['LoansAndOverdrawnBankSharePremiumSubtotal'].value != +this.LoansandoverdrawnbankSoletraderFormgGroup.controls['MatchingData'].value.Item1) {
        Swal.fire("Andica Accounts Production", "Total " + this.commonService.StartYear + " must tally with the Loans and overdrawn bank account balances field value in the Statement of Financial Position for the year " + this.commonService.StartYear + ".", 'warning')
        return false;
      }
      else
        return true
    }

  }


  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.LoansandoverdrawnbankSoletraderFormgGroup.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight:900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?</span>",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.On_Next())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.Router.navigate(['/business']);

  }

  get wizardrowslist() {
    return this.LoansandoverdrawnbankSoletraderFormgGroup.get('Wizardrows') as FormArray;
  }

}
